// eslint-disable-next-line @typescript-eslint/no-var-requires
const questions = require('./questions.yaml');

export { SitelinkCheckEligibility } from './checkEligibility';
export { SitelinkFaqHeroContent } from './heroContent';
export { questions };
